import DeadParkingUpdate from "../../components/DeadParkingUpdate";

const DeadParkingUpdatePage = () => {
  return <DeadParkingUpdate />;
};
export default DeadParkingUpdatePage;
